import { Button } from '../../../shared/components/ui/button'
import { PAGE_ROUTES } from '../../../shared/constants/pages-routes'
import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import { successCheckIconSvg, successfullySentBgImage } from '@/features/auth/constants/image'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

function SuccessFullySentPage() {
    return (
        <AuthBgWrapper image={successfullySentBgImage}>
            <AuthCardWrapper
                headerTitle='Successfully Sent!'
                headerDescription='A password reset link has been sent to your email address. Please check your inbox to proceed.'
                hideLogo
                beforeChildren={
                    <Image
                        src={successCheckIconSvg}
                        alt='Success Check Icon'
                        className='w-[100px] -mb-5'
                    />
                }
            >
                <Button className='w-full' asChild>
                    <Link href={PAGE_ROUTES.login}>
                        Done
                    </Link>
                </Button>
            </AuthCardWrapper>
        </AuthBgWrapper>
    )
}

export default SuccessFullySentPage